import React from 'react'
import Subheader from '../../../component/Subheader'
import OtherRoom from '../../RoomDetail/OtherRoom';
import RoomBanner from '../../RoomDetail/RoomBanner';
import RoomQuote from '../../RoomDetail/RoomQuote';
import RoomCount from '../../RoomDetail/RoomCount';
import RoomGallery from '../../RoomDetail/RoomGallery';
import RoomEquipment from '../../RoomDetail/RoomEquipment';
import RoomBook from '../../RoomDetail/RoomBook';

export default function GoaSuite() {
    const heading = "Suite Room";

    const subheadData = {
        heading: (
                    <>
                    <span className="sr-only">Goa Room</span> {heading}
                    </>
                ),
        breadcrumb: [
            {
                slug: "/resort-de-coracao-goa/room-listing",
                name: (
                        <>
                        <span className="sr-only">{heading}</span> Rooms
                        </>
                    ),
            },
            {
                slug: "",
                name: "Suite Room",
            },
        ]
    }

    const roomBanner = {
        image: "/image/goa-suite-room-detail.webp",
    };

    const roomQuote = {
        content: "This is the ultimate De Coracao experience. Spanning a massive 394 sq. ft., the Suite feels like a private apartment. With a dedicated living area featuring a plush sofa and coffee table, you have a separate space to entertain, read, or just enjoy a quiet coffee before the day begins. It’s bold, beautiful, and built for those who don’t want to compromise on space.",
    };

    const roomCount = {
        bedroom: "1",
        bedsize: "1",
        area: "37",
        bathroom: "1",
        guest: "3",
        balcony: "1"
    };

    const roomGallery = [
        { image: "/image/goa-suite-room-gallery-1.webp" },
        { image: "/image/goa-suite-room-gallery-2.webp" },
        { image: "/image/goa-suite-room-gallery-3.webp" },
        { image: "/image/goa-suite-room-gallery-4.webp" },
        { image: "/image/goa-suite-room-gallery-5.webp" },
        // { image: "/image/goa-suite-room-gallery-6.webp" },
    ];

    const roomEquipment = {
        description: "Thoughtfully planned for modern stays, this room brings together comfort, convenience, and a relaxing atmosphere.",
        equipment: [
        [
            "Separate living room featuring a comfortable sofa and lounge area",
            "Generous 394 sq. ft. layout for complete freedom of movement",
            "Premium Fittings & Hydropneumatic Shower",
            "Premium Pocketed Spring Mattress for a restful sleep",
        ],
        [
            "42-inch LED TV with DTH for your favorite shows",
            "Full Coffee & Tea service station replenished daily",
            "Mini-Refrigerator for your personal snacks and drinks",
            "In-room electronic safe to keep your valuables secure",
        ],
        [
            "Executive Writing Desk for when you need a quiet space to focus",
            "Complimentary High-speed Wi-Fi",
            "Full vanity kit including Hair Dryer & Makeup Mirror",
            "24-Hour Room Service at your beck and call",
            "Evening Turndown service to ensure your room is always fresh",
        ]
    ]
    };

    const roomBook = {
        location: "Goa",
        title: "Suite Room",
        desc: "Step into the spacious Suite Room at De Coracao Goa, designed for guests who value comfort, privacy, and room to unwind. With a separate living area, modern amenities, and elegant interiors, it offers a relaxed stay for families, couples, and leisure travellers.",
        details: [
            " 1 King Size Bed + Living Room Seating",
            "3 Guests",
            "37 sq.mt."
        ],
        enquireLink: "/contact-us",
        bookLink: "https://www.swiftbook.io/inst/#home?propertyId=963MjgsolW0h7uc1ZijJxO0lkzsqHF2oUxvyvlueoPaIL0TFw8FUwK5Ng==&JDRN=Y"
    };


    const otherRoom = {
        slides: [
            {
                title: 'Premium Room',
                bg: '/image/goa-other-room-1.webp',
                slug: '/resort-de-coracao-goa/premium-room',
                details: [
                    "1 King Bed + 1 Extra Mattress ",
                    "Up to 3 Guests",
                    "30 sq mt",
                ],
            },

            {
                title: 'Super Deluxe Room',
                bg: '/image/goa-other-room-2.webp',
                slug: '/resort-de-coracao-goa/super-deluxe-room',
                details: [
                    "1 King Size Bed + 1 Extra Mattress ",
                    "Up to 3 Guests",
                    "28 sq mt",
                ],
            },

            {
                title: 'Standard Room',
                bg: '/image/goa-other-room-6.webp',
                slug: '/resort-de-coracao-goa/standard-room',
                details: [
                    "1 King Size Bed",
                    "2 Guests",
                    "21 sq. mt",
                ],
            },

            {
                title: 'Deluxe Room',
                bg: '/image/goa-other-room-4.webp',
                slug: '/resort-de-coracao-goa/deluxe-room',
                details: [
                    "1 King Size Bed",
                    "2 Guests",
                    "24 sq mt",
                ],
            },
        ],

        allRoom: { link: "/resort-de-coracao-goa/room-listing" }
    }

    return (
        <>
            <Subheader subheadData={subheadData} />
            <RoomBanner roomBanner={roomBanner} />
            <RoomQuote roomQuote={roomQuote} />
            <RoomCount roomCount={roomCount} />
            <RoomGallery roomGallery={roomGallery} />
            <RoomEquipment roomEquipment={roomEquipment} />
            <RoomBook roomBook={roomBook} />
            <OtherRoom otherRoom={otherRoom} roomTitle={`${roomBook.location} ${subheadData.heading}`}/>
        </>
    )
}
